export function createRequestId(): string {
  return Math.random().toString(16).slice(2);
}

export function getRequestId(obj: unknown): string | undefined {
  if (obj != null && typeof obj === 'object') {
    if ('requestId' in obj) {
      return obj.requestId as string;
    }

    if ('graphQLErrors' in obj && Array.isArray(obj.graphQLErrors)) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
      return obj.graphQLErrors[0]?.requestId;
    }
  }
}

export function withRequestId<T extends object>(obj: T, requestId: string): T & { requestId: string } {
  return Object.assign(obj, { requestId });
}

export function fetchWithRequestId(
  fetchImplementation?: typeof fetch,
): (...args: Parameters<typeof fetch>) => Promise<Response & { requestId: string }> {
  const fetchImpl = fetchImplementation ?? fetch;
  return async (url, init) => {
    const requestId = createRequestId();
    return (
      fetchImpl(url, {
        ...init,
        headers: {
          ...init?.headers,
          'Request-Id': requestId,
        },
      })
        .then((response) => Object.assign(response, { requestId }))
        // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
        .catch((error) => {
          Object.assign(error, { requestId });
          throw error;
        })
    );
  };
}
